/**
 * safari-downloader
 *
 * @author    Augusto Silvino <augusto.silvino@mediatel.co.uk>
 * @copyright 2017 Mediatel Limited.
 */

"use strict";

export default () => ({
    isSafariDownloader() {
        const ua = navigator.userAgent.toLowerCase();
        let isSafari = false;
        try {
            isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
                return p.toString() === "[object SafariRemoteNotification]";
            })(!window['safari'] || safari.pushNotification);
        }
        catch(err) {}

        return  (isSafari || ((ua.indexOf('safari') != -1) && (!(ua.indexOf('chrome')!= -1) && (ua.indexOf('version/')!= -1))));
    },

    download(fileContent, mimeType, fileName) {
        const base64 = 'data:' + mimeType + ';base64,' + window.btoa( fileContent );

        const a = document.createElement('a');
        document.body.appendChild(a);
        a.href = encodeURI(base64);
        a.download = fileName;
        a.click();
        document.body.removeChild(a);
    }
});